import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { useBusinessEntityInfo } from './useBusinessEntityInfo';

export const SUBMIT_ADP_REFERRAL_MUTATION = gql`
  mutation SubmitAdpReferralMutation($input: AdpReferralInput!) {
    submitAdpReferral(input: $input)
  }
`;

export function useAdpReferralSubmit() {
  const [submitAdpReferralMutation, { error, loading }] = useMutation(SUBMIT_ADP_REFERRAL_MUTATION, {
    noThrow: true,
  });
  const { businessEntityInfo, loading: businessEntityInfoLoading } = useBusinessEntityInfo();

  const submitAdpReferral = useCallback(
    async (input) => {
      const formationDate = businessEntityInfo?.formationDate;
      const usedFallback = !formationDate && Boolean(businessEntityInfo?.createdAt);
      const effectiveFormationDate = formationDate || businessEntityInfo?.createdAt || '';

      const notes = [];
      if (input?.comments) {
        notes.push(input.comments);
      }
      if (usedFallback) {
        notes.push(`Formation date unavailable - using entity creation date (${effectiveFormationDate}) as fallback.`);
      }

      const response = await submitAdpReferralMutation({
        variables: {
          input: {
            ...input,
            formationDate: effectiveFormationDate,
            comments: notes.join(' '),
          },
        },
      });

      return Boolean(response?.data?.submitAdpReferral);
    },
    [submitAdpReferralMutation, businessEntityInfo],
  );

  useError(error);

  return {
    submitAdpReferral,
    loading: loading || businessEntityInfoLoading,
    hasError: Boolean(error),
  };
}
